const CODE_TYPE = {
  SEARCH: 'help_center_search',
  MAIN_CONTENTS: 'help_center_main_contents',
  MAIN_BANNER: 'help_center_main_banner',
  INQUIRY: 'help_center_inquiry',
  FAQ: 'help_center_faq',
  CHATBOT: 'help_center_chatbot',
} as const;

const BUTTON_TYPE = {
  SEARCH: 'search',
  FAQ: 'faq',
  KEYWORD: 'keyword',
  CATEGORY: 'category',
  CS_GUIDE: 'cs_guide',
  CS_INQUIRY: 'cs_inquiry',
  CS_REPORT: 'cs_report',
  CS_CALL: 'cs_call',
  CS_MY_HISTORY: 'cs_my_history',
  MY_FEEDBACK: 'my_feedback',
  FAQ_FEEDBACK: 'faq_feedback',
  CHATBOT_ICON: 'chatbot_icon',
  CHATBOT_EXIT_ICON: 'chatbot_exit_icon',
  CHATBOT_CONTENTS: 'chatbot_contents',
} as const;

const ACTION_TYPE = {
  TO_LIST: 'to_list',
  TO_AUTO: 'to_auto',
  TO_ALL: 'to_all',
  TO_POPUP_ALL: 'to_popup_all',
  TO_SELECT: 'to_select',
  TO_BROAD: 'to_broad',
  TO_STREAMER: 'to_streamer',
  GATE: 'gate',
  TO_CONTENT: 'to_content',
  TO_ILLEGAL_VIDEO: 'to_illegal_video',
  LIST: 'list',
  TO_YES: 'to_yes',
  TO_NO: 'to_no',
  TO_KEYWORD: 'to_keyword',
  TO_BUTTON: 'to_button',
} as const;

export const HELP_LOG = {
  CODE_TYPE,
  BUTTON_TYPE,
  ACTION_TYPE,
};
